import { html, nothing, render } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { stateful } from "@escapio/shared/components/element-builder";
import { linkTargetForProfile } from "@escapio/portal/components/hotel-list/get-offer-url";
import { hasEscapioRate } from "@escapio/portal/state/escapio-deals-helpers";
import "./EscapioDealBadge";
import "../../HotelFavoriteStatus";
import "../../PictureGallery";
import "../../Zoomable";
import { onChangeCurrency } from "@escapio/portal/state/travelData";

customElements.define(
	"esc-hotel-list-hotel-stage-mobile",
	stateful(
		class extends HTMLElement {
			static getInitialState() {
				return {
					hotel: null,
					currentPicture: 0,
				};
			}

			connectedCallback() {
				onChangeCurrency(() => this.render());
			}

			render() {
				const pictures = this.hotel.list_pictures.pictures.map(filename => ({
					filename,
					alt: this.hotel.list_pictures.alt,
				}));
				const paramSeparator = this.hotel.path.includes("#") ? "&" : "#";

				const template = html`<a
					class="hotel-list-item-mobile__picture-link"
					href="${this.hotel.path}${paramSeparator}selectedStagePicture=${this
						.currentPicture}"
					target=${linkTargetForProfile}
				>
					<div class="hotel-list-item-mobile__picture">
						<esc-picture-gallery
							?track-disabled=${this.hasAttribute("track-disabled")}
							track-category="${this.trackCategory}"
							track-action-suffix="${this.getAttribute(
								"picture-gallery-track-action-suffix",
							)}"
							track-label-suffix="| ${this.hotel.id} | ${this.hotel.name}"
							sizes="mobile:568x284"
							visible-pictures="1"
							preloaded-pictures="1"
							disable-loop
							.pictures="${pictures}"
							.customRenderPicture="${this.renderPicture.bind(this)}"
							?onhold=${this.onhold}
							@PictureChanged=${this.onPictureChanged}
							@click=${() => this.profileLinkHandler(this.currentPicture)}
						></esc-picture-gallery>
						<div
							class="hotel-list-item-mobile__gallery-indicator is-translucent"
						>
							${this.renderGalleryIndicatorDots(pictures)}
						</div>
						${hasEscapioRate(this.hotel) &&
						!this.hasAttribute("hide-escapio-deals-badges")
							? html`<esc-escapio-deal-badge></esc-escapio-deal-badge>`
							: this.hotel.review_score > 0
								? html` <div class="hotel-satisfaction is-translucent">
										<span class="fa fa-thumbs-o-up fa--space-after"></span>
										${this.hotel.review_score}%
									</div>`
								: nothing}
						<esc-hotel-favorite-status
							class="hotel-list-item-mobile__favorite is-translucent"
							hotel-id=${this.hotel.id}
							hotel-name=${this.hotel.name}
							@addToFavorites="${this.addToFavoritesHandler}"
							track-action-suffix="${this.getAttribute(
								"favorites-track-action-suffix",
							)}"
							only-icon
						>
						</esc-hotel-favorite-status>
					</div>
				</a>`;
				render(template, this, { host: this });
			}

			renderGalleryIndicatorDots(pictures) {
				return pictures.map(
					(_, index) =>
						html`<span
							class="gallery-indicator__dot ${classMap({
								"gallery-indicator__dot--active": index === this.currentPicture,
							})}"
						></span>`,
				);
			}

			renderPicture(_, __, renderPictureFn) {
				return html`<esc-zoomable
					?track-disabled=${this.hasAttribute("track-disabled")}
					event-category="${this.trackCategory}"
					event-action="Bild Zoom"
					event-label-suffix=" | ${this.hotel.id} | ${this.hotel.name}"
					@ZoomStart="${() => (this.showPictureDescription = false)}"
					@ZoomEnd="${() => (this.showPictureDescription = true)}"
					>${renderPictureFn()}</esc-zoomable
				>`;
			}

			onPictureChanged({ detail }) {
				this.currentPicture = detail.currentPicture;
			}

			get trackCategory() {
				return this.getAttribute("track-category");
			}
		},
	),
);
